import React from 'react'
import { FieldArray } from 'formik'
import { fireEvent } from 'highcharts'

const RenderFieldArray = ({ field, values, newItem, children, allowZero, inline }) => {
    const childElement = React.Children.toArray(children)[0]

    return (
        <FieldArray name={field}>
            {({ push, remove }) => {
                return (
                    <>
                        {values &&
                            values.length > 0 &&
                            values.map((value, index) => (
                                <div key={index} className="array-row col-section col-no-margin">
                                    {React.cloneElement(childElement, {
                                        value: value,
                                        index: index,
                                    })}

                                    <div className={inline ? 'col-md-3 ' : 'col-xs-12 '}>
                                        {index === values.length - 1 && (
                                            <button
                                                className="btn btn-right"
                                                type="button"
                                                onClick={() => push(newItem)}
                                                style={{ marginLeft: '20px' }}
                                            >
                                                +
                                            </button>
                                        )}

                                        {(values.length > 1 || allowZero) && (
                                            <button
                                                className="btn btn-right"
                                                type="button"
                                                onClick={() => {
                                                    remove(index)
                                                }}
                                            >
                                                x
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}

                        {values && values.length === 0 && (
                            <div key="no-items-only-add" className="array-row">
                                <div className="col-section col-no-margin">
                                    <div className="col-xs-12">
                                        <button
                                            className="btn btn-right"
                                            type="button"
                                            onClick={() => push(newItem)}
                                            style={{ marginLeft: '20px' }}
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )
            }}
        </FieldArray>
    )
}

export default RenderFieldArray
